var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77757 1.88973C3.77732 2.39067 3.57808 2.87099 3.22369 3.22502C2.8693 3.57906 2.38878 3.77782 1.88784 3.77757C1.3869 3.77732 0.906583 3.57808 0.552544 3.22369C0.198506 2.8693 -0.000250232 2.38878 2.36439e-07 1.88784C0.000250705 1.3869 0.199487 0.906583 0.55388 0.552544C0.908273 0.198506 1.38879 -0.000250232 1.88973 2.36439e-07C2.39067 0.000250705 2.87099 0.199487 3.22502 0.55388C3.57906 0.908273 3.77782 1.38879 3.77757 1.88973ZM3.83423 5.17621H0.0566637V17H3.83423V5.17621ZM9.80279 5.17621H6.04411V17H9.76501V10.7953C9.76501 7.33887 14.2698 7.01778 14.2698 10.7953V17H18.0001V9.51097C18.0001 3.68407 11.3327 3.90128 9.76501 6.76279L9.80279 5.17621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c71a17db092cbcbceedd0e9ac0359d2f.svg";
export { ForwardRef as ReactComponent };